import { render, staticRenderFns } from "./no_results_warning.vue?vue&type=template&id=9b2b9d46&scoped=true&"
import script from "./no_results_warning.vue?vue&type=script&lang=js&"
export * from "./no_results_warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2b9d46",
  null
  
)

export default component.exports